import React, { useState } from 'react';
import { resetPasswordWithFirebase } from '../lib/firebaseAuth';
import '../csscomponent/AuthAssist.css';
import useSingleTapNavigate from '../lib/useSingleTapNavigate';
import LogoButtonLoader from './mobile/LogoButtonLoader';

export default function ForgotPassword() {
  const { goTo, navLocked } = useSingleTapNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setMessage('Enter your email address.');
      return;
    }
    if (!validateEmail(email.trim())) {
      setMessage('Enter a valid email address.');
      return;
    }

    try {
      setLoading(true);
      const result = await resetPasswordWithFirebase({ email: email.trim() });
      setMessage(result?.message || 'If this email exists, a reset link has been sent.');
    } catch (error) {
      setMessage(error?.message || 'Unable to send reset link right now.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-assist-page">
      <div className="auth-assist-card">
        <div className="auth-assist-topbar">
          <button
            type="button"
            className="auth-assist-back"
            onClick={() => goTo('/login')}
            disabled={navLocked}
          >
            Back to Login
          </button>
          <button
            type="button"
            className="auth-page-skip auth-assist-skip"
            onClick={() => goTo('/home')}
            disabled={navLocked}
          >
            Skip
          </button>
        </div>
        <h1>Forgot Password</h1>
        <p>Enter your email and we will send you a secure reset link.</p>
        <form onSubmit={onSubmit} className="auth-assist-form">
          <label htmlFor="forgot-email">Email</label>
          <input
            id="forgot-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="name@example.com"
            required
          />
          <button type="submit" disabled={loading}>
            {loading ? (
              <LogoButtonLoader text="Sending link..." />
            ) : (
              'Send reset link'
            )}
          </button>
        </form>
        {message ? <p className="auth-assist-message">{message}</p> : null}
      </div>
    </div>
  );
}
